import React, { useEffect, useState } from 'react';

type Open = (event: React.MouseEvent<HTMLAnchorElement>) => void;

const useDrawerMenu = (): {
  open: Open;
  anchorEl: HTMLElement | null;
  close: () => void;
  onMenuEnter: () => void;
  onButtonLeave: () => void;
  onButtonEnter: () => void;
} => {
  const [buttonLeave, setButtonLeave] = useState<boolean>(false);
  const [menuEnter, setMenuEnter] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | undefined>(undefined);
  const open = (event: React.MouseEvent<HTMLAnchorElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onButtonLeave = () => {
    const newTimer = setTimeout(() => setButtonLeave(true), 50);
    setTimer(newTimer);
  };

  const onButtonEnter = () => {
    clearTimeout(timer);
    setButtonLeave(false);
  };

  const onMenuEnter = () => {
    setMenuEnter(true);
  };

  const close = () => {
    setAnchorEl(null);
    setButtonLeave(false);
    setMenuEnter(false);
  };

  useEffect(() => {
    if (buttonLeave && !menuEnter) {
      close();
    }
  }, [buttonLeave, menuEnter, timer]);

  return {
    open,
    close,
    anchorEl,
    onButtonLeave,
    onButtonEnter,
    onMenuEnter,
  };
};

export default useDrawerMenu;
